import React, { useState } from 'react'

const BombaStrawberries = () => {
    const [isMarqueeActive, setIsMarqueeActive] = useState(false)

    return (
        <div className='d-flex flex-column flex-fill h-100'>
            <div>
                <img className='w-100' src="assets/img/bomba-strawberries-header-img.png" alt="" />
            </div>
            <div className=' flex-fill bomba-strawberries'>
                <span className={`marquee-strawberries ${isMarqueeActive ? 'active' : ''}`.trim()}>
                    <span style={{ width: "200px" }}><img className='img-fluid w-100' src="assets/img/bomba-strawberries.gif" alt="" /></span>
                </span>
                <div className='strawberries-bonus-no'>0123456</div>
            </div>
            <div className='bomba-strawberries-footer d-flex justify-content-between align-items-center bg-black p-3 pt-1'>
                <div className='left-content'>aperte<span>“jogar”</span></div>
                <span className='position-relative' onClick={() => setIsMarqueeActive(true)}>
                    <img className="img-fluid" src="assets/img/jogar-btn-img.png" alt="" />
                    {/* <span className="btn-red position-absolute top-0 end-0 bottom-0 start-0">
                        <span className="btn-name text-black">Jogar</span>
                    </span> */}
                </span>
                <div className="d-flex flex-column ">
                    <span className='text-content text-3d '>Premio</span>
                    <span className='Premio-btn position-relative'>
                        <img className='img-fluid' src="assets/img/premio-btn-img.png" alt="" />
                        <span className='btn-text-content'>235</span>
                    </span>
                </div>
            </div>
        </div>
    )
}

export default BombaStrawberries